import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { MessageProvider } from './context/MessageContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Alerts from './components/Alerts';
import Home from './pages/Home';
import CreateCarOffer from './pages/CreateCarOffer';
import CarRequests from './pages/CarRequests';
import CarOffers from './pages/CarOffers';
import Profile from './pages/Profile';
import Test from './pages/Test';
import './App.css';
import './output.css';
import axios from 'axios';

axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('accessToken')}`;

function App() {
   function Greeting({ name }) {
    return <h1>Такой страницы не существует. {name}!</h1>;
  }
  return (
    <MessageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Header />
          <Routes>
            <Route index element={<Home />} />
            <Route path="createCarOffer" element={<CreateCarOffer />} />
            <Route path="CarRequests" element={<CarRequests />} />
            <Route path="CarOffers" element={<CarOffers />} />
            <Route path="Profile" element={<Profile />} />
            <Route path="*" element={<Greeting name="Гость" />} />
          </Routes>
          <Alerts alId='container' />
          <Footer />
        </BrowserRouter>
      </AuthProvider>
    </MessageProvider>
  );
}

export default App;
